import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const WarningTriangle = ({
  size,
  type,
  theme,
  className,
  dataTestId = "warning-triangle-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M8.705 11.646a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7.43 5.98a.667.667 0 0 0-.664.721l.247 2.972a.333.333 0 0 0 .332.306h.72a.333.333 0 0 0 .333-.306l.247-2.972a.667.667 0 0 0-.664-.722H7.43Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.969 2.341c.768-1.344 2.705-1.344 3.473 0l5.702 9.98c.762 1.332-.2 2.992-1.736 2.992H2.003c-1.536 0-2.498-1.66-1.737-2.993L5.97 2.341Zm2.315.661a.667.667 0 0 0-1.157 0l-5.703 9.98a.667.667 0 0 0 .579.997h11.405a.667.667 0 0 0 .579-.997l-5.703-9.98Z"
    />
  </SVGIcon>
);
